import React, { useEffect, useRef, useCallback, useState } from "react"
import { useLocation } from "react-router-dom"
import PropTypes from "prop-types"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import { routes } from "routes/path"
import { useSelector } from "react-redux"

// const { RoleName } = JSON.parse(localStorage.getItem("authUser"))

const SidebarContent = props => {
  const [RoleName, setRoleName] = useState(
    JSON.parse(localStorage.getItem("authUser"))
  )
  useEffect(() => { }, [props.success])
  const financeAmountShowHide = useSelector(state => state.ReduxData.finaceAmountShow);

  const ref = useRef()
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()

  const activeMenu = useCallback(() => {
    let pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName == routes.userCreate || pathName == routes.userUpdate) {
        pathName = routes.userList
      }
      if (
        pathName == routes.createProduct ||
        pathName == routes.updateproduct
      ) {
        pathName = routes.productList
      }
      if (
        pathName == routes.createbooking ||
        pathName == routes.updatebooking ||
        pathName == routes.viewBooking
      ) {
        pathName = routes.bookingList
      }
      if (
        pathName == routes.createSale ||
        pathName == routes.updateSale
      ) {
        pathName = routes.salesList
      }
      if (
        pathName == routes.createPurchase ||
        pathName == routes.UpdatePurchase
      ) {
        pathName = routes.purchaseList
      }
      if (
        pathName == routes.CreateCreditNote
      ) {
        pathName = routes.CreditNote
      }
      if (
        pathName == routes.createmanufactureProduct ||
        pathName == routes.updatemanufactureProduct
      ) {
        pathName = routes.manufactureProduct
      }
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }


    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])


  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  return (
    <>
      {RoleName.RoleName == "Admin" ? (
        <React.Fragment>

          <SimpleBar className="h-100" ref={ref}>
            <div id="sidebar-menu">
              <ul className="metismenu list-unstyled" id="side-menu">
                <li>
                  <Link to={routes.userList}>
                    <i className="bx bxs-user-rectangle"></i>
                    <span >{props.t("Users")}</span>
                  </Link>
                </li>
                <li>
                  <Link to={routes.setting}>
                    <i className="bx bxs-cog"></i>
                    <span>{props.t("Setting")}</span>
                  </Link>
                </li>
                {/* <li>
                  <Link to={routes.dbBackup}>
                    <i className="bx bxs-data"></i>
                    <span>{props.t("Db-Backup")}</span>
                  </Link>
                </li> */}
              </ul>
            </div>
          </SimpleBar>
        </React.Fragment>
      ) : RoleName.RoleName == "Vendor" ? (
        <React.Fragment>
          <SimpleBar className="h-100" ref={ref}>
            <div id="sidebar-menu">
              <ul className="metismenu list-unstyled" id="side-menu">
                <li className="menu-title">{props.t("Dashboard")} </li>
                <li>
                  <Link to={routes.dashboard}>
                    <i className="bx bx-home-circle"></i>
                    <span>{props.t("Dashboard")}</span>
                  </Link>
                </li>
                <li>
                  <Link to={routes.available}>
                    <i className="bx bx-calendar-check"></i>
                    <span>{props.t("Generate Bill")}</span>
                  </Link>
                </li>
                <li>
                  <Link to={routes.catalogue}>
                    <i className="bx bx-images"></i>
                    <span>{props.t("Stock")}</span>
                  </Link>
                </li>

                <li className="menu-title">{props.t("Menu")}</li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-file"></i>
                    <span>{props.t("Master")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to={routes.userList}>{props.t("Users")}</Link>
                    </li>
                    <li>
                      <Link to={routes.categories}>
                        {props.t("Categories")}
                      </Link>
                    </li>
                    <li>
                      <Link to={routes.size}>{props.t("Size")}</Link>
                    </li>
                    <li>
                      <Link to={routes.color}>{props.t("Colors")}</Link>
                    </li>
                    <li>
                      <Link to={routes.timeslot}>{props.t("Time Slots")}</Link>
                    </li>
                    <li>
                      <Link to={routes.reminder}>{props.t("Reminder")}</Link>
                    </li>
                    <li>
                      <Link to={routes.accounts}>{props.t("Accounts")}</Link>
                    </li>
                    <li>
                      <Link to={routes.feedbackQuestion}>{props.t("Feedback Question")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-store"></i>
                    <span>{props.t("Inventory")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to={routes.productList}>{props.t("Products")}</Link>
                    </li>
                    <li>
                      <Link to={routes.importProduct}>
                        {props.t("Import Product")}
                      </Link>
                    </li>
                    <li>
                      <Link to={routes.items}>{props.t("Items")}</Link>
                    </li>
                    <li>
                      <Link to={routes.Washing}>{props.t("Washing")}</Link>
                    </li>
                    <li>
                      <Link to={routes.manufactureProduct}>{props.t("Manufacture Product")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-money"></i>
                    <span>{props.t("Transaction")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to={routes.bookingList}>{props.t("Bookings")}</Link>
                    </li>
                    {/* <li>
                      <Link to={routes.HoldBillList}>{props.t("Hold Bills")}</Link>
                    </li> */}
                    <li>
                      <Link to={routes.income}>{props.t("Income")}</Link>
                    </li>
                    <li>
                      <Link to={routes.expenses}>{props.t("Expense")}</Link>
                    </li>
                    <li>
                      <Link to={routes.salesList}>{props.t("Sales")}</Link>
                    </li>
                    {/* <li>
                      <Link to={routes.purchaseList}>{props.t("Purchases")}</Link>
                    </li>
                    <li>
                      <Link to={routes.journalVouchers}>{props.t("Journal Vouchers")}</Link>
                    </li> */}
                    <li>
                      <Link to={routes.CreditNote}>{props.t("Credit Notes")}</Link>
                    </li>
                    {/* <li>
                      <Link to={routes.HoldBillList}>{props.t("Hold Bills")}</Link>
                    </li> */}
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="  bx bxs-detail"></i>
                    <span>{props.t("Report")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to={routes.delivery}>{props.t("Delivery")}</Link>
                    </li>
                    <li>
                      <Link to={routes.return}>{props.t("Return")}</Link>
                    </li>
                    <li>
                      <Link to={routes.deposit}>{props.t("Deposit")}</Link>
                    </li>
                    <li>
                      <Link to={routes.subCategories}>{props.t("Sub Categories")}</Link>
                    </li>
                    <li>
                      <Link to={routes.pendingBills}>{props.t("Pending Bills")}</Link>
                    </li>
                    <li>
                      <Link to={routes.productHistory}>
                        {props.t("Product History")}
                      </Link>
                    </li>
                    <li>
                      <Link to={routes.bookedOrdersReport}>
                        {props.t("Booked Orders")}
                      </Link>
                    </li>
                    {financeAmountShowHide &&
                      <li>
                        <Link to={routes.incomeExpense}>{props.t("Income/Expense")}</Link>
                      </li>
                    }

                    {financeAmountShowHide &&
                      <li>
                        <Link to={routes.bookingOutstanding}>{props.t("Booking Outstanding")}</Link>
                      </li>
                    }
                    <li>
                      <Link to={routes.salesman}>{props.t("Salesman")}</Link>
                    </li>
                    <li>
                      <Link to={routes.InquiryData}>
                        {props.t("Inquiries")}
                      </Link>
                    </li>
                    <li>
                      <Link to={routes.feedbackReport}>
                        {props.t("Feedbacks")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to={routes.setting}>
                    <i className="bx bxs-cog"></i>
                    <span>{props.t("Setting")}</span>
                  </Link>
                </li>
                {/* <li>
                  <Link to={routes.dbBackup}>
                    <i className="bx bxs-data"></i>
                    <span>{props.t("Db-Backup")}</span>
                  </Link>
                </li> */}
                {/* <li>
                  <Link to={routes.tutorialForVendor}>
                    <i className="bx bx-video"></i>
                    <span>{props.t("Tutorial")}</span>
                  </Link>
                </li> */}
                {/* <li>
                  <Link to={routes.releseNote}>
                    <span className="badge rounded-pill text-bg-success float-end" key="t-new">New</span>
                    <i className="bx bx-notepad"></i>
                    <span>{props.t("What's New")}</span>
                  </Link>
                </li> */}
              </ul>
            </div>
          </SimpleBar>
        </React.Fragment>
      ) : RoleName.RoleName == "Manufacture" ? (
        <React.Fragment>
          <SimpleBar className="h-100" ref={ref}>
            <div id="sidebar-menu">
              <ul className="metismenu list-unstyled" id="side-menu">
                <li className="menu-title">{props.t("Menu")}</li>
                <li>
                  <Link to={routes.manufactureProduct}>
                    <i className="bx bx-file"></i>
                    <span>{props.t("Manufacture Product")}</span>
                  </Link>
                </li>
              </ul>
            </div>
          </SimpleBar>
        </React.Fragment>
      ) : (
        <SimpleBar className="h-100" ref={ref}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li>
                <Link to={routes.available}>
                  <i className="fas fa-calendar-check"></i>
                  <span>{props.t("Generate Bill")}</span>
                </Link>
              </li>
              <li>
                <Link to={routes.catalogue}>
                  <i className="bx bx-images"></i>
                  <span> {props.t("Catalogue")}</span>
                </Link>
              </li>
              {/* <li>
                <Link to={routes.tutorialForVendor}>
                  <i className="bx bx-video"></i>
                  <span>{props.t("Tutorial")}</span>
                </Link>
              </li> */}
            </ul>
          </div>
        </SimpleBar>
      )}
    </>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
